import React from 'react';
import SignUpForm from 'components/forms/SignUpForm';
import small1 from 'images/hero-images/Signup-Hero-1-Small-768x439.jpg';
import medium1 from 'images/hero-images/Signup-Hero-1-Medium-1024x585.jpg';
import large1 from 'images/hero-images/Signup-Hero-1-Large-1550x885.jpg';
// @ts-ignore
import sample from 'lodash-es/sample';
import { MEDIA_QUERY_SMALL_DOWN, MEDIA_QUERY_MEDIUM_DOWN } from 'utils/constants/breakpoints';
import small2 from 'images/hero-images/Signup-Hero-2-Small-768x439.jpg';
import medium2 from 'images/hero-images/Signup-Hero-2-Medium-1024x585.jpg';
import large2 from 'images/hero-images/Signup-Hero-2-Large-1550x885.jpg';
import small3 from 'images/hero-images/Pro-Hero-1-Small-768x439.jpg';
import medium3 from 'images/hero-images/Pro-Hero-1-Medium-1024x585.jpg';
import large3 from 'images/hero-images/Pro-Hero-1-Large-1550x885.jpg';
import small4 from 'images/hero-images/Pro-Hero-2-Small-768x439.jpg';
import medium4 from 'images/hero-images/Pro-Hero-2-Medium-1024x585.jpg';
import large4 from 'images/hero-images/Pro-Hero-2-Large-1550x885.jpg';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import * as styles from './styles.module.scss';

const {
  A_PERSON_WTIH_LONG_BROWN_HAIR_IS_WEARING_ORANGE_PANTS,
  TWO_PEOPLE_ARE,
  A_SMILING_PERSON,
  A_PERSON_WTIH_LONG_BROWN_HAIR_IS_WEARING_A_BLACK_HAT
} = StringConstantsMixin.strings;

const SIGNUP_IMAGES = [
  { alt: A_PERSON_WTIH_LONG_BROWN_HAIR_IS_WEARING_ORANGE_PANTS, small: small1, medium: medium1, large: large1 },
  { alt: TWO_PEOPLE_ARE, small: small2, medium: medium2, large: large2 },
  { alt: A_SMILING_PERSON, small: small3, medium: medium3, large: large3 },
  { alt: A_PERSON_WTIH_LONG_BROWN_HAIR_IS_WEARING_A_BLACK_HAT, small: small4, medium: medium4, large: large4 }
];

interface Props {
  handleRegistrationSuccess: () => void;
  referralLink: string;
}

function Signup({ handleRegistrationSuccess, referralLink }: Props) {
  const { alt, small, medium, large } = sample(SIGNUP_IMAGES);

  return (
    <div className={styles.signup}>
      <picture className={styles.picture}>
        <source srcSet={small} media={MEDIA_QUERY_SMALL_DOWN} />
        <source srcSet={medium} media={MEDIA_QUERY_MEDIUM_DOWN} />
        <img alt={alt} className={styles.image} src={large} />
      </picture>
      <div className={styles.form}>
        <SignUpForm handleRegistrationSuccess={handleRegistrationSuccess} referralLink={referralLink} />
      </div>
    </div>
  );
}

export default Signup;
